import IconButton from '@material-ui/core/IconButton';
import { withStyles } from '@material-ui/core/styles';
import Tooltip from '@material-ui/core/Tooltip';
import Typography from '@material-ui/core/Typography';
import AttachFileIcon from '@material-ui/icons/AttachFile';
import { Component, default as React } from 'react';
import Dropzone from 'react-dropzone';
import GS from '../../grafsync/grafsync';
import PrimaryButton from '../PrimaryButton';
import { globalStyles } from '../style/gstheme';
import TitledTextField from '../TitledTextField';
import { createLengthWarning, makeCancelable } from '../utils/utils';
import Warning from '../Warning';

const styles = theme => {
  return Object.assign({
    importIcon: {
      height: 24,
      width: 24,
      color: theme.palette.grey[500]
    },
    attachInner: {
      display: 'flex',
      marginTop: 8,
      marginRight: 12,
      border: 'none'
    },
    file: {
      maxWidth: '240px',
      fontSize: '14px',
      paddingTop: 4,
      paddingLeft: 6,
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap'
    }
  }, globalStyles);
};

class SelectFile extends React.Component {

  state = {
    dragging: false
  };

  render() {

    const { classes, filename, onSelectFile } = this.props;
    const invalid = filename && filename.match(/.*\..*\..*/) !== null;

    return (
      <div>
        <Dropzone
          accept="image/jpg, image/png"
          maxSize={5242880}
          onDrop={acceptedFiles => onSelectFile(acceptedFiles)}>
          {({ getRootProps, getInputProps }) => (
            <div data-test="drop-zone" {...getRootProps()} className={classes.attachInner}>
              <Tooltip title="Attach a JPG or PNG image.">
                <IconButton data-test="attach-file" size="small">
                  <AttachFileIcon className={classes.importIcon} />
                </IconButton>
              </Tooltip>
              <input {...getInputProps()} />
              {filename &&
                <Typography data-test="attachment"
                  variant="body2"
                  className={classes.file}
                  style={{
                    ...(invalid) && {
                      color: '#DD2C00'
                    }
                  }}>
                  {filename}
                </Typography>
              }
            </div>
          )}
        </Dropzone>
      </div>
    );
  }
}

class UserInfo extends Component {

  constructor(props) {
    super(props);
    this.state = {
      feedback: "",
      uploading: false,
      filename: null,
      completed: false
    };
  }

  uploadFeedback = async () => {
    this.setState({ uploading: true });
    this.cancellable = makeCancelable(
      GS.sendFeedback(this.state.file, this.state.feedback, this.props.project)
        .then(resp => {
          if (this.cancellable && !this.cancellable.isCancelled()) {
            this.setState({
              filename: null,
              feedback: "",
              uploading: false,
              completed: true
            });
          }
        })
        .catch((e) => {
          if (this.cancellable && !this.cancellable.isCancelled()) this.setState({
            isErrored: true,
            errorMessage: e.message,
            uploading: false,
            completed: false
          });
        })
    );
    return this.cancellable;
  };

  handleChange = (event) => {
    const t = event.target;
    this.setState({ [t.name]: t.value, completed: false });
  };

  onSelectFile = (data) => {
    // Only accept one file
    if (data.length === 0 || data.length > 1) return;
    this.setState({ filename: data[0].path, file: data[0] });
  };

  sendFeedback = () => {
    this.uploadFeedback();
  };

  onExitWarning = () => this.setState({ warning: "", isErrored: false });

  render() {

    const { feedback, filename, isErrored, errorMessage, uploading, completed } = this.state;
    const { classes } = this.props;

    // Do not allow double extensions
    const invalid = filename && filename.match(/.*\..*\..*/) !== null;

    return (
      <div>
        {completed &&
          <Typography data-test="feedback-confirmation" paragraph variant="body2">Your feedback has been sent. Thank you.</Typography>
        }
        <TitledTextField
          dataTest="feedback"
          name="feedback"
          title="Feedback"
          autoFocus
          readOnly={uploading}
          text={feedback}
          multiline={true}
          placeholder="We would love to hear your feedback."
          maxLength={1000}
          helperText={createLengthWarning(feedback, 1000)}
          onEnter={feedback.trim().length > 0 ? this.sendFeedback : null}
          onChange={this.handleChange} />
        <div style={{ display: 'flex', width: '100%' }}>
          <div style={{ flex: 1 }}>
            {uploading ?
              <div className={classes.attachInner}>
                <AttachFileIcon className={classes.importIcon} />
                <Typography
                  data-test="attachment"
                  variant="body2"
                  className={classes.file}>
                  {filename}
                </Typography>
              </div>
              :
              <SelectFile classes={classes} onSelectFile={this.onSelectFile} filename={filename} />
            }
          </div>
          <div style={{ flex: '0 0' }}>
            <PrimaryButton disabled={invalid || uploading || feedback.trim().length === 0} onClick={this.sendFeedback}>Send</PrimaryButton>
          </div>
        </div>
        {isErrored && <Warning message={errorMessage} onExitWarning={this.onExitWarning} />}
      </div>
    );
  }
}

export default withStyles(styles)(UserInfo);